import { InjectionToken } from '@angular/core';
import { IEnvironment } from '../environment-types';

export const ENVIRONMENT_CONFIG_TOKEN = new InjectionToken<Partial<IEnvironment>>('environment');
